import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "../../index.scss";

//Panels
import Modal from "../../../Modal/Modal";

//Images
import patios1 from "../../../images/categories/patios/PPI-patio-001.jpg";
import patios2 from "../../../images/categories/patios/PPI-patio-002.jpg";
import patios3 from "../../../images/categories/patios/PPI-patio-003.jpg";
import patios4 from "../../../images/categories/patios/PPI-patio-004.jpg";
import patios5 from "../../../images/categories/patios/PPI-patio-005.jpg";
import patios6 from "../../../images/categories/patios/PPI-patio-006.jpg";
import patios7 from "../../../images/categories/patios/PPI-patio-007.jpg";
import patios8 from "../../../images/categories/patios/PPI-patio-008.jpg";
import patios9 from "../../../images/categories/patios/PPI-patio-009.jpg";
import patios10 from "../../../images/categories/patios/PPI-patio-010.jpg";
import patios11 from "../../../images/categories/patios/PPI-patio-011.jpg";
import patios13 from "../../../images/categories/patios/PPI-patio-013.jpg";
import patios14 from "../../../images/categories/patios/PPI-patio-014.jpg";
import patios15 from "../../../images/categories/patios/PPI-patio-015.jpg";
import patios16 from "../../../images/categories/patios/PPI-patio-016.jpg";
import patios17 from "../../../images/categories/patios/PPI-patio-017.jpg";
import patios18 from "../../../images/categories/patios/PPI-patio-018.jpg";
import patios19 from "../../../images/categories/patios/PPI-patio-019.jpg";
import patios20 from "../../../images/categories/patios/PPI-patio-020.jpg";
import patios21 from "../../../images/categories/patios/PPI-patio-021.jpg";
import patios22 from "../../../images/categories/patios/PPI-patio-022.jpg";
import patios23 from "../../../images/categories/patios/PPI-patio-023.jpg";
import patios24 from "../../../images/categories/patios/PPI-patio-024.jpg";
import patios25 from "../../../images/categories/patios/PPI-patio-025.jpg";
import patios27 from "../../../images/categories/patios/PPI-patio-027.jpg";
import patios28 from "../../../images/categories/patios/PPI-patio-028.jpg";
import patios29 from "../../../images/categories/patios/PPI-patio-029.jpg";
import patios30 from "../../../images/categories/patios/PPI-patio-030.jpg";
import patios31 from "../../../images/categories/patios/PPI-patio-031.jpg";
import patios32 from "../../../images/categories/patios/PPI-patio-032.jpg";
import patios33 from "../../../images/categories/patios/PPI-patio-033.jpg";

//Utils
import { mapGallery } from "../../../../../Utils/Utils";

// SEO
import SEO from "../../../../../SEO/index.js";
import StructuredData from "../../../../../SEO/structuredData";

const Patios = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    {
      image: patios1,
      description:
        "Small paving stone patio with fountains, waterfall and pond, and a succulent wall planter.",
      aria: "Small paving stone patio with fountains, waterfall and pond, and a succulent wall planter",
    },
    {
      image: patios2,
      description:
        "Hollywood paving stone patio and pool deck in sand and earth-tone colors. A lighter paving stone was used around the pool lip to segment the pool from the patio space.",
      aria: "Hollywood paving stone patio and pool deck in sand and earth-tone colors",
    },
    {
      image: patios3,
      description:
        "Traditional paving stone patio with matching water feature and rustic outdoor furniture.",
      aria: "Traditional paving stone patio with matching water feature and rustic outdoor furniture",
    },
    {
      image: patios4,
      description:
        "Porcelain paving stone patio and steps surrounding a flagstone outcropping. This outdoor design showcases regal structure with the use of porcelain pavers, and an organic feel with the flagstone.",
      aria: "Porcelain paving stone patio and steps surrounding a flagstone outcropping",
    },
    {
      image: patios5,
      description:
        "Paving stone patio with a brick accent and lining. The raised patio area blends perfectly with the lower level because the charcoal pavers and brick lining were carried through throughout the design.",
      aria: "Paving stone patio with a brick accent and lining with outdoor kitchen and furniture",
    },
    {
      image: patios6,
      description:
        "Flagstone patio and brick fire pit. A wooden pergola provides shading for the space and segments the dining area from the fire pit space.",
      aria: "Flagstone patio and brick fire pit with a  wooden pergola covering outdoor furniture.",
    },
    {
      image: patios7,
      description:
        "Pool deck and patio made of flagstones with freestanding pergola, outdoor kitchen and fireplace.",
      aria: "Pool deck and patio made of flagstones with freestanding pergola, outdoor kitchen and fireplace",
    },
    {
      image: patios8,
      description:
        "Porcelain paving stone patio in Encino, CA. Elegant and sleep porcelain pavers were used to create this understated patio space.",
      aria: "Porcelain paving stone patio in Encino, CA with outdoor furniture",
    },
    {
      image: patios9,
      description:
        "Geometric concrete slab patio in Encino, CA. This modern design features a gas fire pit and polished stones to segment the concrete slabs.",
      aria: "Geometric concrete slab patio in Encino, CA with a gas fire pit and polished stones",
    },
    {
      image: patios10,
      description:
        "Flagstone patio and dining area with attached pergola for shading.",
      aria: "Flagstone patio and dining area with attached pergola",
    },
    {
      image: patios11,
      description:
        "Paving stone pool deck, patio and outdoor kitchen with a free-standing pergola. This backyard is fully hardscape with sand colored paving stones and combines to make an open concept yard.",
      aria: "Paving stone pool deck, patio and outdoor kitchen with a free-standing pergola",
    },
    {
      image: patios13,
      description:
        "Raised patio and seating area constructed with porcelain pavers and featuring a freestanding pergola and fire pit.",
      aria: "Raised patio & seating area constructed with porcelain pavers & a freestanding pergola & fire pit",
    },
    {
      image: patios14,
      description:
        "Rustic flagstone patio with seating area, small pool and fire pit in Los Angeles, CA. Complete with an outdoor kitchen, fire feature, string lights and water feature, this backyard is an entertainer's paradise.",
      aria: "Patio with seating area, pool & fire pit in LA with an outdoor kitchen, lights & water feature",
    },
    {
      image: patios15,
      description:
        "Covered patio constructed from porcelain pavers and small accent tiles, featuring an outdoor fireplace and outdoor seating.",
      aria: "Covered patio constructed from porcelain pavers & accent tiles with an outdoor fireplace & seating",
    },
    {
      image: patios16,
      description:
        "Large backyard with stamped concrete and artificial turf walkway, paving stone patio, fire feature made from complimentary flagstone and an outdoor kitchen.",
      aria: "Backyard with stamped concrete & turf walkway, paving stone patio, fire feature, & outdoor kitchen",
    },
    {
      image: patios17,
      description:
        "Expansive paving stone pool deck, patio and fire pit area. A custom built outdoor kitchen equipped with porcelain pavers is also located adjacent from the pool.",
      aria: "Paving stone pool deck, patio, fire pit area, custom built outdoor kitchen adjacent from the pool",
    },
    {
      image: patios18,
      description:
        "Patio, outdoor kitchen and fire pit area constructed with large charcoal paving stones. The custom gas fire pit was made from flagstone material to match the flagstone used in the geometric pattern and astroturf.",
      aria: "Patio, outdoor kitchen and fire pit area constructed with large charcoal paving stones",
    },
    {
      image: patios19,
      description:
        "Seating area with topiary garden boxes over porcelain paving stones and artificial turf.",
      aria: "Seating area with topiary garden boxes over porcelain paving stones and artificial turf",
    },
    {
      image: patios20,
      description:
        "Traditional english garden patio and seating over a paving stone patio in Encino, CA.",
      aria: "Traditional english garden patio and seating over a paving stone patio in Encino, CA",
    },
    {
      image: patios21,
      description:
        "Redesign of the patio space for the 2019 Pasadena House of Design in Altadena, CA. The full design includes a porcelain paving stone patio coupled with artificial turf, a dining table, drought tolerant planting and a water feature.",
      aria: "Porcelain paving stone patio with turf, a dining table, drought tolerant plants & a water feature.",
    },
    {
      image: patios22,
      description:
        "Contemporary outdoor space with beautiful porcelain pavers set in a geometric pattern with artificial turf framing them. The use of porcelain pavers ties into the regalness of the rest of the estate and brings more usability to the home.",
      aria: "Outdoor space with porcelain pavers set in a geometric pattern with artificial turf framing them",
    },
    {
      image: patios23,
      description:
        "Modern patio design with fire feature in the hills of Eagle Rock, CA. Large concrete slabs with polished stones in between make up this sleek and understated design and are finished off with an “L” shape fire feature.",
      aria: "Patio with fire feature, outdoor furniture, and plants in the hills of Eagle Rock, CA",
    },
    {
      image: patios24,
      description:
        "Poolside gazebo in Beverly Hills, CA. This small poolside cabana/seating area was custom built and includes porcelain planks as the hardscape.",
      aria: "Poolside gazebo in Beverly Hills, CA overlooking inground pool and patio",
    },
    {
      image: patios25,
      description:
        "Tumbled paving stones make up this pond-side patio in Glendale, CA. This rustic design includes a custom-built outdoor kitchen and expansive koi pond to elevate the Al Fresco dining experience.",
      aria: "Tumbled paving stones pond-side patio in Glendale, CA with outdoor kitchen and furniture",
    },
    {
      image: patios27,
      description:
        "Paving stone patio that leads to a small side yard walkway with a water feature.",
      aria: "Paving stone patio that leads to a small side yard walkway with a water feature",
    },
    {
      image: patios28,
      description:
        "The 2017 Pasadena Showcase House of Design custom outdoor table with a built-in water feature and porcelain paving stone planks.",
      aria: "Outdoor table with a built-in water feature and porcelain paving stone planks",
    },
    {
      image: patios29,
      description: "Porcelain tile patio with concrete slab.",
      aria: "Porcelain tile patio with concrete slab and inground pool",
    },
    {
      image: patios30,
      description:
        "Modern outdoor dining area with a retractable awning, custom water feature table, outdoor lighting, drought tolerant planting and porcelain paving stone planks.",
      aria: "Outdoor dining area with awning, table, lighting, plants & porcelain paving stone planks",
    },
    {
      image: patios31,
      description:
        "Pasadena patio complete with porcelain paver planks, contemporary outdoor seating and a retractable shade structure.",
      aria: "Pasadena patio with porcelain paver planks, contemporary outdoor seating & a shade structure",
    },
    {
      image: patios32,
      description:
        "Lower level paving stone walkway leading up to a brick patio with outdoor seating and outdoor kitchen.",
      aria: "Lower level paving stone walkway leading up to a brick patio with outdoor seating & outdoor kitchen",
    },
    {
      image: patios33,
      description:
        "Covered brick patio with outdoor lighting, outdoor heating and furniture.",
      aria: "Covered brick patio with outdoor lighting, outdoor lighting and furniture",
    },
  ];

  return (
    <>
      <SEO
        title="Paver Patio Ideas | Southern California | Pacific Pavingstone"
        description="SView the beautiful paver patio projects we've completed in Southern California. Gain inspiration and ideas for your next project today!"
        profileURL={"https://www.pacificpavingstone.com/gallery/patios"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Completed Paver Patio Gallery",
          description:
            "View the beautiful paver patio projects we've completed in Southern California. Gain inspiration and ideas for your next project today!",
          image:
            "https://www.pacificpavingstone.com/static/media/patios-banner.a3ab1fd0.jpg",
          URL: "https://www.pacificpavingstone.com/contact-us",
        }}
      />
      <div className="container-fluid no-side-padding gallery-wrapper">
        {/* <div className="row justify-content-center hero-unit">
          <div className="col-12 no-side-padding">
            <div className="title">
              <Link to="/gallery">Back to Gallery</Link>
              <h1>Patios Gallery</h1>
            </div>
          </div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "patios", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default Patios;
